import React from 'react';

/**
 * SCR-6808: Show warning when Medicare is selected but Medical Necessity has not been acknowledged by the client.
 * SCR-8106: Do not show alert if the client has signed and confirmed.
 *
 * If the billingMethod value is supplied we will use it to determine if Medicare is selected. If billingMethod is
 *  not supplied we will loop through the order's requisitions, checking for any that have the Medicare billing method.
 *  This is done so the message will toggle on/off on the Billing Options page based on the selected option instead of
 *  based on the saved requisition details.
 *
 * @param gearOrder The order being viewed/registered
 * @param billingMethod An optional billing method value to use when determining the selected billing method
 */
export default function MedicareDiscardAlert({ gearOrder, billingMethod }) {
	const firstReqId = gearOrder?.requisitions?.find((req) => req.reqNumber)?.reqNumber;
	const showMedicareDiscardWarning =
		!(gearOrder?.practAgreement && gearOrder?.workflow?.practitionerConfirmed) && // Practitioner has signed and confirmed
		!gearOrder?.dateMedicalNecessityAcknowledged && // Medical Necessity has not been acknowledged by the client
		firstReqId && // The message references a req number so it only makes sense to show when we have a req number
		(billingMethod === process.env.REACT_APP_BILLING_MEDICARE_VALUE || // Medicare is the selected billing method
			// OR we don't have a selected billing method (Not on the billing page) and one of the reqs has the Medicare billing method
			(!billingMethod &&
				gearOrder?.requisitions?.some(
					(req) => req.billingMethod === process.env.REACT_APP_BILLING_MEDICARE_VALUE
				)));

	if (!showMedicareDiscardWarning) {
		return null;
	}

	return (
		<div className="alert alert-danger">
			Your physician has not registered your test online. If you are a Medicare or Tricare beneficiary, your test
			will be discarded by the laboratory if your physician does not register. Please contact your physician to
			ask that they register your test online with ID number {firstReqId}.
		</div>
	);
}
